import { useQuery } from "react-query";
import axios from "axios";
import {useSelector } from "react-redux";
import {apiUrlSelector} from "../redux/selectors";

export const useWOJDEs = (filter, onSuccess) => {
    const apiUrl = useSelector(apiUrlSelector);
    
    const filterString = filter ? Object.keys(filter).map( f => `${f}=${filter[f]}`).join("&") : "";
    
    return useQuery(["jde-work-orders", filter, apiUrl], () =>
        axios.get(`${apiUrl}jde-work-orders${filterString.length > 0 ? `?${filterString}` : ""}`).then(res => {
            if ( onSuccess ) {
                return onSuccess(res.data.data);   
            } else {
                return res.data.data;
            }
        }),
        {
            refetchOnWindowFocus: false,
            placeholderData: []
        }
    );
};

export default useWOJDEs;